import './MobileMenuBack.scss';
import './NavLink.scss';
import React from 'react';
import PropTypes from 'prop-types';
import CaretIcon from 'components/shared/icons/CaretIcon';

class MobileMenuBack extends React.Component {
  static propTypes = {
    callback: PropTypes.func.isRequired,
    stringID: PropTypes.string.isRequired,
  }

  static contextTypes = {
    getString: PropTypes.func.isRequired,
  };

  render() {
    const { callback, stringID } = this.props;
    const { getString } = this.context;

    /* TODO: Use <button> instead of <a> */
    return (
      <a href="#" onClick={callback} className="aa-nav-link aa-nav-back">
        <CaretIcon direction="left" size={14} />
        &nbsp;&nbsp;
        {getString(stringID)}
      </a>
    );
  }
}

export default MobileMenuBack;
